import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import classNames from 'classnames';
import ChevronDown from '@/icons/ChevronDown';
import SidebarItem from './SidebarItem';
import type { SidebarAccordionProps } from './Sidebar.types';

const SidebarAccordion = ({
  title,
  url,
  id,
  linkingMode,
  subcategories,
}: SidebarAccordionProps) => {
  const [isOpen, setIsOpen] = useState(linkingMode !== 'link');

  return (
    <motion.div>
      <AnimatePresence>
        <SidebarItem
          title={title}
          id={id}
          url={url}
          linkingMode={linkingMode}
          subcategories={null}
        />

        <motion.button
          title="Toggle accordion"
          key={`${id}-button`}
          className={classNames('sidebar__accordion-button', {
            'sidebar__accordion-button--open': isOpen,
          })}
          onClick={() => setIsOpen(!isOpen)}
        >
          <ChevronDown width={11} />
        </motion.button>

        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            key={`${id}-subcategories`}
            animate={{
              opacity: 1,
              transition: {
                duration: 0.5,
              },
            }}
            exit={{ opacity: 0 }}
          >
            <ol className="sidebar__list sidebar__list--subcategories">
              {subcategories.map((subcategory) => (
                <li
                  className="sidebar__list-item sidebar__list-item--subcategory"
                  key={subcategory.title}
                >
                  <SidebarItem {...subcategory} />

                  {subcategory.subcategories.length > 0 &&
                    subcategory.linkingMode !== 'link' && (
                      <ol>
                        {subcategory.subcategories.map((subSubcategory) => (
                          <li key={subSubcategory.id}>
                            <SidebarItem {...subSubcategory} />
                          </li>
                        ))}
                      </ol>
                    )}
                </li>
              ))}
            </ol>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default SidebarAccordion;
